var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-round-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.293,
    height: 28.293,
    viewBox: "0 0 28.293 28.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66250",
    "data-name": "Path 66250",
    d: "M28.293,14.146a14.146,14.146,0,1,0-17.564,13.73V18.469H7.812V14.146h2.917V12.284c0-4.815,2.179-7.047,6.906-7.047a15.6,15.6,0,0,1,3.076.352V9.507c-.334-.035-.914-.053-1.634-.053-2.32,0-3.216.879-3.216,3.163v1.529h4.621l-.794,4.323H15.86v9.72A14.148,14.148,0,0,0,28.293,14.146Z",
    fill: "#0866ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66251",
    "data-name": "Path 66251",
    d: "M152.415,107.442l.794-4.323h-4.621v-1.529c0-2.285.9-3.163,3.216-3.163.72,0,1.3.018,1.634.053V94.562a15.6,15.6,0,0,0-3.076-.352c-4.727,0-6.906,2.232-6.906,7.047v1.863H140.54v4.323h2.917v9.407a14.24,14.24,0,0,0,5.131.313v-9.72Z",
    transform: "translate(-132.728 -88.973)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d36a901dcda2d7a6f1a302fb0c2bb182.svg";
export { ForwardRef as ReactComponent };